import { FunctionComponent } from 'react';
import Highlighter from 'react-highlight-words';

import { HIGHLIGHT_PROPS } from 'components/company/CompanyTable/CompanyName/constants';
import useQuery from 'hooks/useQuery';
import useSearchWords from 'hooks/useSearchWords';

export interface CompanyNameProps {
  name: string;
  type: string;
}

const CompanyName: FunctionComponent<CompanyNameProps> = function ({
  name,
  type,
}) {
  const [query] = useQuery('companies');
  const searchWords = useSearchWords(query);

  return (
    <div className="flex flex-col text-16-20 text-neutral-900">
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={name || ''}
        className="text-16-20-em"
      />
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={type?.replace(/_/g, ' ') || ''}
      />
    </div>
  );
};

export default CompanyName;
